import { Component, ElementRef } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { BARCOLOR, DiagramDatas } from '../../diagram/diagram.component';

interface Result {
  result : Array<any>
}

@Component({
  selector: 'app-unfall',
  templateUrl: './unfall.component.html',
  styleUrls: ['./unfall.component.css']
})
export class UnfallComponent {
  unfall;
  versorgung = false;
  
  diagramDatas : Array<DiagramDatas> = [undefined, undefined];

  diagramDataInits : Array<DiagramDatas> = [
    {
      height: 400,
      diagrams: []    
    },
    {
      height: 300,
      diagrams: []    
    }
  ];
  
  
  constructor(
    private elementRef: ElementRef,
    private api: ApiService
  ) {   
    this.api.getUnfall().then((values) => {
      this.unfall = values;
      this.diagramDataInits[0].diagrams.push({
        bars: [
          {
            value: this.unfall.ergVersorgungszielUnfall.value,
            color: BARCOLOR.blue,
            left: "Versorgungsziel"     
          },
          {
            value: this.unfall.ergVersorgungslueckeUnfall.value,
            color: BARCOLOR.red,
            right: "Versorgungslücke",
          }           
        ]
      });
      
      this.diagramDataInits[1].diagrams.push({
        bars: [
          {
            value: this.unfall.kapitalbedarfUnfall,
            color: BARCOLOR.blue,
            left: "Kapitalbedarf"     
          },
          {
            value: this.unfall.ergVorhandenesKapitalUnfall.value,
            color: BARCOLOR.red,
            right: "Versorgungslücke",
          }           
        ]
      });
      
      this.diagramDataInits.forEach( (obj,idx) => {
        this.diagramDatas[idx] = Object.assign({}, obj);
      })
       
    }, (error) => {
      alert( error );
    });
  }
  
  toggle(i) {
    switch (i) {
      case 0:
        this.versorgung = true;
        break;
      case 1:
        this.versorgung = false;
        break;   
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/auswertung/unfall/unfall.component.ts